<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/user/create-user"><i class="fas fa-user-plus">
                </i>Create Users</button> -->
        </div>

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">System Parameters</h5>

                <app-loader [show]="showLoader"></app-loader>

                <!-- server search  -->
                <!-- <form class="server-search-table p-3" [formGroup]="emailForm" (submit)="getUserByName()">
                    <div class="form-group">
                        <input type="text" class="form-control" placeholder="Search" formControlName="email">
                        <button type="submit" class="btn-search-table">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </form>

                <app-loader [show]="searching"></app-loader> -->

                <div class="table-responsive py-3" style="padding: 1rem!important" *ngIf="showLoader==false">
                    <table class="table-striped" class="table" id="datatable">
                        <thead>
                            <tr>
                                <th>Parameter Code</th>
                                <th>Parameter Value</th>
                                <th class="border-0 font-14 px-2 text-grey"
                                    *ngIf="globals.checkUserHasPermission('SYS_PARAMETERS - QUERY')">{{ "MODIFY" |
                                    translate | titlecase }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of systemParamData; let i = index">
                                <td class="cursor-pointer">{{res.parameterCode}}</td>
                                <td class="cursor-pointer">{{res.parameterValue}}</td>
                                <td class="text-bold text-warning"
                                    *ngIf="globals.checkUserHasPermission('SYS_PARAMETERS - QUERY')">
                                    <button class="btn btn-sm btn-link text-warning" (click)="getCurrentSysParam(i)"
                                        data-toggle="modal" data-target="#update"><i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</button>
                                </td>
                            </tr>
                        </tbody>

                    </table>

                    <!-- server footer 
                    <div class="d-flex justify-content-between flex-wrap p-3">
                        <div>
                            <b>Showing</b> {{currentIndex * pageLength + 1}} - {{usersSearch.length + currentIndex *
                            pageLength}}
                            <b>of</b>
                            {{totalRecords}}
                        </div>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination pagination-sm flex-wrap">
                                <li class="page-item rounded-0">
                                    <a class="page-link border-0" (click)="getNewData(currentIndex - 1)"
                                        [class.disabled]="currentIndex == 0">Previous</a>
                                </li>
                                <li class="page-item rounded-0" [class.active]="currentIndex == i"
                                    *ngFor="let page of paging;let i=index">
                                    <a class="page-link border-0 " (click)="getNewData(i)">{{i+1}}</a>
                                </li>
                                <li class="page-item rounded-0">
                                    <a class="page-link border-0" (click)="getNewData(currentIndex + 1)"
                                        [class.disabled]="currentIndex == paging.length - 1">Next</a>
                                </li>
                            </ul>
                        </nav>
                    </div> -->

                </div>
            </div>
        </div>


    </div>
</div>

<!-- update -->
<div class="modal fade" id="update" tabindex="-1" aria-labelledby="update" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <form class="modal-content col-md-12" [formGroup]="updateSysParam" (submit)="updateSysParamSubmit()">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "EDIT_SYS_PARAMETER" | translate | titlecase }}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeEdit>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body px-md-12">
                <div class="row">
                    <div class="col-md-12 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "PARAMETER_VALUE" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="parameterValue">
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="updateSysParam.controls.parameterValue.touched && updateSysParam.controls.parameterValue.invalid && updateSysParam.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="close-ChronicDiseases" class="btn btn-outline-secondary"
                    data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase }}</button>
            </div>
        </form>
    </div>
</div>